<template>
  <div class="page-wrapper">
    <div class="page-content--bge5">
      <div class="container">
        <div class="login-wrap">
          <div class="login-content">
            <div class="login-logo">
              <img alt="NP-CDN" src="/images/logo.png" class="sidebar-logo">
            </div>
            <div class="login-form">
              <div class="text-center" style="color: red;" v-if="error">{{ error }}</div>
              <form @submit.prevent="onSubmit">
                <div :class="{invalid: $v.form.email.$error}" class="form-group">
                  <label for="email">
                    {{ text('email') }}
                  </label>
                  <input @blur="$v.form.email.$touch()"
                         autocomplete="username email"
                         class="au-input au-input--full"
                         id="email"
                         :placeholder="text('email_placeholder')"
                         type="email"
                         v-model.trim="form.email">
                </div>
                <div :class="{invalid: $v.form.password.$error}" class="form-group">
                  <label for="password">
                    {{ text('password') }}
                  </label>
                  <input @blur="$v.form.password.$touch()"
                         autocomplete="current-password"
                         class="au-input au-input--full"
                         id="password"
                         name="password"
                         :placeholder="text('password')"
                         type="password"
                         v-model="form.password">
                </div>
                <div class="login-checkbox">
                  <label></label>
                  <label>
                    <router-link :to="{name: 'ForgetPass'}" tag="a">
                      {{ text('forgotten_password') }}
                    </router-link>
                  </label>
                </div>
                <button :disabled="isLoaded"
                        class="au-btn au-btn--block au-btn--green m-b-20"
                        type="submit">
                  <span class="spinner-border spinner-grow-sm" style="margin-bottom: 4px; margin-right: 4px;"
                        v-if="isLoaded"></span>{{ text('sign_in') }}
                </button>
              </form>
              <div class="register-link">
                <p>
                  {{ text('sign_up_text') }}
                  <router-link :to="{name: 'SignUp'}" tag="a">
                    {{ text('sign_up') }}
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import { STORE_TYPES } from '@/store/modules/types';

export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      error: '',
      isLoaded: false,
    };
  },
  computed: {
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  methods: {
    onSubmit() {
      this.error = '';
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;

      const formData = {
        username: this.form.email,
        password: this.form.password,
      };

      this.isLoaded = true;
      this.$store.dispatch('login', formData)
        .then(() => {
          this.$store.dispatch('fetchUser')
            .then(() => {
              this.$store.dispatch('changeProject', STORE_TYPES.PROJECT_CODE.CDN);
              this.$router.push({ name: 'CDNDashboard' });
            })
            .catch((errorMsg) => {
              this.error = errorMsg;
            });
        })
        .catch((errorMsg) => {
          this.error = errorMsg;
        })
        .finally(() => {
          this.isLoaded = false;
        });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>

<style scoped>
  .invalid label {
    color: red;
  }

  .invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }
</style>
